import { useState } from "react";
import { useOutletContext } from "react-router-dom";
// types
import TOutletContext from "@/cms/types/TOutletContext";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EContentMetricsType from "@/core/enums/EContentMetricsType";
// hooks
import useContentMetrics, { TContentMetric } from "@/hooks/useContentMetrics";
import { isEmpty } from "lodash";


type TRender<T={}> = {

    showView?:boolean;
    showLike?:boolean;
    showDownload?:boolean;
    showCopyPath?:boolean;
    showAll?:boolean;

    enableTitle?:boolean;
    enableIcon?:boolean;

    className?:string;
    itemClassName?:string;

} & T;

type TContentMetricsString<T=any> = {

    contentId:string;

}  & TRender;

const WriteString = (props:{enableTitle?:boolean, value:string, index:number, length:number}) => {
    if ( !props.enableTitle ) return null;
    return ` ${props.value}${props.index+1<props.length ? ", ": ""}`;
}

const DrawIcon = (props:{enableIcon?:boolean, icon:any}) => {
    if ( !props.enableIcon ) return null;
    return props.icon
}

const Render = ( props: TRender<{contentMetrics:TContentMetric[]}> ) => {

    const { siteSettingPayload } = useOutletContext<TOutletContext>();

    const { 
        contentMetrics, 
        showView=false, showLike=false, showDownload=false, showCopyPath=false, showAll=true, enableTitle=false, enableIcon=true,
        className, itemClassName 
    } = props;
    const contentMetricsLength = contentMetrics.length;

    const [viewString] = useState(metaDataLanguageVersion("viewString", siteSettingPayload.languageVersions));
    const [likeString] = useState(metaDataLanguageVersion("likeString", siteSettingPayload.languageVersions));
    const [downloadString] = useState(metaDataLanguageVersion("downloadString", siteSettingPayload.languageVersions));
    const [copyPathString] = useState(metaDataLanguageVersion("copyPathString", siteSettingPayload.languageVersions));

    return (
        <div className={className}>
            {
                contentMetrics.map((item, index) => {
                    if ( item.metricType === EContentMetricsType.VIEW && (showView || showAll) ) {
                        return (
                            <span className={itemClassName} title={viewString}>
                                <DrawIcon enableIcon={enableIcon} icon={<i className="fa-solid fa-eye" />} />
                                {item.count} 
                                <WriteString enableTitle={enableTitle} index={index} length={contentMetricsLength} value={viewString} />
                            </span>
                        )
                    }
                    else if ( item.metricType === EContentMetricsType.LIKE && ( showLike || showAll) ) {
                        return (
                            <span className={itemClassName} title={likeString}>
                                <DrawIcon enableIcon={enableIcon} icon={<i className="fa-solid fa-thumbs-up" />} />
                                {item.count} 
                                <WriteString enableTitle={enableTitle} index={index} length={contentMetricsLength} value={likeString} />
                            </span>
                        )
                    }
                    else if ( item.metricType === EContentMetricsType.DOWNLOAD && ( showDownload || showAll) ) {
                        return (
                            <span className={itemClassName} title={downloadString}>
                                <DrawIcon enableIcon={enableIcon} icon={<i className="fa-solid fa-download" />} />
                                {item.count}
                                <WriteString enableTitle={enableTitle} index={index} length={contentMetricsLength} value={downloadString} />
                            </span>
                        )
                    }
                    else if ( item.metricType === EContentMetricsType.COPY_PATH && ( showCopyPath || showAll) ) {
                        return (
                            <span className={itemClassName} title={copyPathString}>
                                <DrawIcon enableIcon={enableIcon} icon={<i className="fa-solid fa-copy" />} />
                                {item.count} 
                                <WriteString enableTitle={enableTitle} index={index} length={contentMetricsLength} value={copyPathString} />
                            </span>
                        )
                    }
                    return null;
                })
            }
        </div>
    )

}

const ContentMetricsString = ( props:TContentMetricsString ) => {
    console.log("ContentMetricsString.rendered: ", props);

    
    const { contentId } = props;

    const unqKey = `${contentId.split("-")[4]}CM`;
    const contentMetrics = useContentMetrics({unqKey, contentId});
    
    if ( !unqKey || !contentMetrics.payload || isEmpty(contentMetrics.payload) ) return null;

    return <Render 
                contentMetrics={contentMetrics.payload} 
                showView={props.showView}
                showLike={props.showLike}
                showDownload={props.showDownload}
                showCopyPath={props.showCopyPath}
                showAll={props.showAll}

                enableTitle={props.enableTitle}
                enableIcon={props.enableIcon}

                className={props.className}
                itemClassName={props.itemClassName}  
            />
}

export default ContentMetricsString;